const chip = {
  MuiChip: {
    styleOverrides: {
      root: {
        fontSize: '12px',
        fontWeight: 500,
        height: '30px',
        borderRadius: '4px',
      },
      label: {
        padding: 0,
      },
    },
  },
};
export default chip;
